import { collection, orderBy, query } from "firebase/firestore";
import { db } from "@poseidon/firebase/firebase";
import { useEffect, useState } from "react";
import { useCollection } from "react-firebase-hooks/firestore";

export const useCountries = (withCode) => {
  const [countries, setCountries] = useState([]);
  const [value, loading, error] = useCollection(
    query(collection(db, "countries"), orderBy("country", "asc"))
  );
  useEffect(() => {
    const run = () => {
      if (value) {
        const docs = value.docs.map((snap) => ({
          country: snap.get("country"),
          ...(withCode ? { code: snap.get("code") } : {}),
        }));
        setCountries(docs);
      }
    };
    run();
  }, [value, withCode]);

  return { countries, loading, error };
};
